export const LOGEVENT_SUBMODULE = {
  Empresas: 'accountsTab',
  Contactos: 'contactsTab',
  Expedientes: 'opportunitiesTab',
  tblAgenda: 'eventsAndTasksTab',
  Gestiones: 'activitiesTab',
  tblSalesOrders: 'salesOrdersTab',
  Productos: 'productsTab',
  tblUsuarios: 'usersTab'
};